/**
 * Love Store Paris — Checkout direct Offre VIP
 */
(function () {
  'use strict';

  function setLoading(form, isLoading) {
    if (isLoading) {
      form.classList.add('lsp-offre-vip-checkout-form--loading');
    } else {
      form.classList.remove('lsp-offre-vip-checkout-form--loading');
    }

    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = !!isLoading;
  }

  function getVariantId(form) {
    var input = form.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  function runVipCheckout(form, variantId) {
    if (window.LspOffreVipCart && typeof window.LspOffreVipCart.addVipAndCheckout === 'function') {
      window.LspOffreVipCart.addVipAndCheckout(variantId).catch(function (error) {
        setLoading(form, false);
        window.alert(error && error.message ? error.message : 'Impossible d\'ajouter le bon d\'achat.');
      });
      return;
    }

    form.submit();
  }

  function submitCheckout(form, waitForCartApi) {
    var variantId = getVariantId(form);
    if (!variantId) return;

    setLoading(form, true);

    if (!waitForCartApi) {
      runVipCheckout(form, variantId);
      return;
    }

    var attempts = 0;
    (function poll() {
      if (window.LspOffreVipCart && typeof window.LspOffreVipCart.addVipAndCheckout === 'function') {
        runVipCheckout(form, variantId);
        return;
      }

      attempts += 1;
      if (attempts >= 40) {
        runVipCheckout(form, variantId);
        return;
      }

      setTimeout(poll, 25);
    })();
  }

  function initCheckoutForm(form) {
    if (!form || form.dataset.lspOffreVipCheckoutInit === 'true') return;
    form.dataset.lspOffreVipCheckoutInit = 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submitCheckout(form, false);
    });
  }

  function autoSubmit(form) {
    initCheckoutForm(form);
    submitCheckout(form, true);
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('.lsp-offre-vip-checkout-form').forEach(initCheckoutForm);
    scope.querySelectorAll('[data-lsp-offre-vip-auto-checkout]').forEach(autoSubmit);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
